module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Lucy Ellis\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Lucy Ellis has four loves in life: books, expensive lingerie, vintage films and big, gorgeous men who have to duck going through doorways. Weaving aspects of them into her fiction is the best part of being a romance writer. Lucy lives in a small cottage in the foothills outside Melbourne. "), _c('BR'), _vm._v(" Recent titles by the same author "), _c('BR'), _vm._v(" INNOCENT IN THE IVORY TOWER "), _c('BR'), _vm._v(" Did you know this title is also available as eBook? "), _c('BR'), _vm._v(" Visit www.millsandboon.co.uk")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/mnPNQh/tc-custom/9781460303566.jpg?1703768014674",
      "alt": "This image is the cover for the book Pride After Her Fall"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Pride After Her Fall\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Bankrupt, homeless and alone, Lorelei St. James is an heiress on the edge. Yet she hides her desperation behind her glossy blond hair and even brighter smile. Getting lectured on her driving by a hot-temperedand ridiculously attractivestranger will "), _c('i', [_vm._v("not")]), _vm._v(" be what shatters her carefully crafted facade!"), _c('br'), _c('br'), _vm._v("Legendary Australian racing driver Nash Blue knows a thing or two about pride and sees straight through Lorelei’s polished front. Her vulnerabilities play havoc with his concentration. Never shy of a challenge, he begins his biggest yet: unwrapping the real Lorelei St. James.")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Harlequin\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0